<template>
    <div class="datagrid-wrapper">
        <div class="row">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-6">
                        <h1> Access Requests </h1>
                        <div class="search-form_wrapper">
                            <div class="search-form-mask open">
                                <input type="text" class="search-input" v-model="query">
                                <button class="btn btn-light sb-icon-search" v-on:click="search">
                            <span class="fa fa-search">
                                <span class="visually-hidden">Search</span>
                            </span>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-2">
                        <div class="type-selector">
                            <multiselect
                                v-model="selectedTypes"
                                :options="availableTypes"
                                track-by="name"
                                label="name"
                                placeholder="Any Type"
                                :searchable="false"
                                @input="search"
                                :internal-search="true"
                                :allow-empty="true"
                                :multiple="true"
                            ></multiselect>
                        </div>
                    </div>
                </div>
            </div>
            <div data-type="grid" class="col-md-12">
                <table class="datagrid table access-request-list">
                    <thead>
                        <tr>
                            <th><h4>Name (Requested For) </h4></th>
                            <th><h4>Request Type</h4></th>
                            <th><h4>Requested By</h4></th>
                            <th><h4>Requested On</h4></th>
                            <th><h4>Actions</h4></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="!response?.data">
                            <td colspan="7">
                                <span class="spinner anim-spin"></span>
                            </td>
                        </tr>
                        <tr v-else-if="!response?.data?.length">
                            <td colspan="7">No access requests found</td>
                        </tr>
                        <tr v-for="request in response.data" v-bind:key="request.id">
                            <td>
                                <span v-html="resolveRequestedFor(request)"></span>
                            </td>
                            <td>{{ request.type }}</td>
                            <td>{{ request.requester.full_name }} <i> ({{ request.requester.email }}) </i> </td>
                            <td>{{ $formatDate(request.created_at, user_date_format, 'HH:mm:ss', centre.time_zone_id) }}</td>
                            <td><a v-if="request.is_viewable" :href="`/approval-request/${request.id}`" class="btn btn-link link-button">View</a></td>
                        </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <td colspan="3">
                            <div class="is-text-centered">
                                <full-pagination
                                    v-bind:pagination="response"
                                    v-bind:content="response.data"
                                    v-bind:offset="10"
                                    @paginate="getPages">
                                </full-pagination>
                            </div>
                        </td>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>

<script>

import Access from "../Services/Access";
import Multiselect from 'vue-multiselect';
import FullPagination from "./UI/FullPagination.vue";
import he from 'he/he';
import {initTooltips} from "../Services/Tooltip";

export default {
        name: "AccessRequestsTableComponent",
        components: {
            Multiselect, FullPagination
        },
        props: {
            centre: {
                type: Object,
            },
            searchForId: {
                type: [Number, null],
                required: false,
            },
            user_date_format: {
                type: String,
            },
        },
        data: function() {
          return {
              response: {},
              query: '',
              selectedTypes: [],
              availableTypes: [],
          }
        },
        mounted() {
            if (this.searchForId) {
                this.getSingleApprovalRequest();
            } else {
                this.getApprovalRequests();
            }

            this.getAvailableTypes();
        },
        methods: {
            getPages: function(page) {
                this.response.current_page = page;
                let url = this.response.path + "?page=" + page;
                this.getApprovalRequests(url);
            },

            getAvailableTypes: function() {
                Access.fetchAvailableTypes().then((response) => {
                    this.availableTypes = response;
                });
            },

            getApprovalRequests: function(url) {
                Access.fetchApprovalRequests(this.centre.id, url).then((response) => {
                   this.response = response;
                   this.$nextTick(() => {
                       let tooltipTriggerList = this.$el.querySelectorAll('[data-bs-toggle="tooltip"]');
                       initTooltips(tooltipTriggerList);
                   });
                });
            },
            getSingleApprovalRequest: function() {
                Access.getApprovalRequest(this.searchForId).then((response) => {
                    this.response = response;
                });
            },
            resolveRequestedFor: function (request) {

                if (request.companies.length === 1) {
                    return request.companies[0].name;
                }

                if (request.companies.length > 1) {
                    let info = request.companies.map(company => company.name);
                    return '<a href="" data-bs-toggle="tooltip" data-bs-html="true" title="' + info.join('</br>') + '">Multiple Companies</a>';
                }

                if (request.requested_for_with_trashed.length === 1) {
                    return he.escape(request.requested_for_with_trashed[0].full_name);
                }

                if (request.requested_for_with_trashed.length > 1) {
                    let info = request.requested_for_with_trashed.map(user => user.full_name);

                    return '<a href="" data-bs-toggle="tooltip" data-bs-html="true" title="' + info.join('</br>') + '">Multiple Users</a>';
                }

                return 'N/A';

            },
            search: function () {
                let types = this.selectedTypes.map((type) => { return type['code']; }).join(',');
                Access.searchApprovalRequests(this.centre.id, this.query, types).then((response) => {
                    this.response = response;
                });
            }
        }
    }
</script>

<style scoped>
.access-request-list > tbody > tr > td:not(:last-child) {
    padding-right: 40px;
}


.search-input {
    position: absolute;
    top: 0;
    right: 0;
    outline: none;
    height: 30px;
    margin: 0;
    z-index: 10;
    font-family: inherit;
    border-radius: 22px;
    color: #babfbf;
    box-shadow: none;
    border: 1px solid #979ca2;
    padding: 6px 12px;
    font-size: 14px;
    line-height: 1.6;
    width: 250px;
}

.search-input__button {
    background: #fff;
    filter: alpha(opacity=0);
    opacity: 0;
    color: transparent;
    border: none;
    outline: none;
    width: 25px;
}

.search-form_wrapper {
    margin-left: 15px;
}

.datagrid-wrapper .search-form-mask.open {
    width: 250px;
}


</style>
